import Image from "next/legacy/image";
import { Lazy, Mousewheel, Navigation, Pagination } from 'swiper';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Photo } from "../../../../types/HotelType";

import style from './ListHotelImageCarousel.module.scss';
import 'swiper/css'
import "swiper/css/pagination";
import "swiper/css/navigation";

type ListHotelImageCarouselProps = {
  photos: Photo[];
  slidesPerView?: number;
}

export function ListHotelImageCarousel({photos, slidesPerView}: ListHotelImageCarouselProps) {

  return (
    <Swiper
      modules={[Pagination, Navigation, Mousewheel, Lazy]}
      pagination={{ dynamicBullets: true }}
      navigation={true}
      mousewheel={true}
      className={style.swiper}
      slidesPerView={slidesPerView}
    >
      {photos.map((item, i) => (
      <SwiperSlide key={i} className={style.SwiperSlide}>
          <Image width={50} height={38} layout='responsive' key={i} src={item.img_sml} alt={item.alt} />
      </SwiperSlide>
          ))}
    </Swiper>
  )
}